import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimalnumber]'
})
export class DecimalnumberDirective {

  // Allow decimal numbers and negative values
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete'];
  // private regex = new RegExp(/^\d+(\.\d{0,4})?$/);
  @Input() min: number | string | null;
  @Input() max: number | string | null;

  private allowedDecimals = 4;

  constructor(private el: ElementRef<HTMLInputElement>) { }

  ngOnInit() {
    // this.allowedDecimals = this.getDecimalLength(this.max);

    if (this.max !== null && this.max !== undefined) {
      this.allowedDecimals = this.getDecimalLength(this.max);
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const current = this.el.nativeElement.value;
    const next = current + event.key;

    // only allow a leading '-' when this field's own DB-driven Min permits negative values
    const allowNegative = this.min !== null && this.min !== undefined && Number(this.min) < 0;
    const sign = allowNegative ? '-?' : '';

    // Decimal regex based on max decimal places
    const regex = new RegExp(
      `^${sign}\\d*(\\.\\d{0,${this.allowedDecimals}})?$`
    );

    if (!regex.test(next)) {
      event.preventDefault();
    }
  }

  // 🔹 Blur validation (value complete ayyaka)
  @HostListener('blur')
  onBlur() {
    let value = parseFloat(this.el.nativeElement.value);

    if (isNaN(value)) {
      this.el.nativeElement.value = '';
      return;
    }

    if (this.min !== null && this.min !== undefined && value < Number(this.min)) {
      value = Number(this.min);
    }

    if (this.max !== null && this.max !== undefined && value > Number(this.max)) {
      value = Number(this.max);
    }

    value = Number(value.toFixed(this.allowedDecimals));
    this.el.nativeElement.value = value.toString();
  }
  private getDecimalLength(value: number | string): number {
    const parts = value.toString().split('.');
    return parts.length > 1 ? parts[1].length : 0;
  }

}
